import { useEffect } from "react";
import {
  SiteConfigBuilder,
  SiteConfigCookieStore,
  AuthFlowBuilder,
  AuthFlowParams
} from "@monorepo/libraries";
import { Brand, useBrand, useWauth } from "@monorepo/components";

function mapBrandToTenant (brand: Brand): string {
  switch (brand) {
    case Brand.VistaCreate:
      return "vistacreate";
    case Brand["99Designs"]:
      return "99designs";
    default:
      return "vistaprint";
  }
}

function getCookieDomainForSubdomains (): string {
  return `.${window.location.hostname}`;
}

function useSiteConfigPersistor (
  getCookieDomain: () => string | null = getCookieDomainForSubdomains
): void {
  const brand: Brand = useBrand();
  const wauth: any = useWauth();

  useEffect(() => {
    const siteConfigBuilder: SiteConfigBuilder = new SiteConfigBuilder();

    const tenant: string = mapBrandToTenant(brand);
    siteConfigBuilder.withTenant(tenant);
    const segmentInfo = {
      anonymousId: wauth.anonymousId,
      culture: wauth.culture,
      site: wauth.site,
      visit: wauth.visit,
      ga: wauth.ga
    };
    window.localStorage.setItem("segmentInfo", JSON.stringify(segmentInfo));
    const authParams: AuthFlowParams = new AuthFlowBuilder().build();
    if (wauth.site && wauth.site !== tenant) {
      siteConfigBuilder.withTenant(wauth.site.toLowerCase());
    }
    if (authParams.culture) {
      siteConfigBuilder.withCulture(authParams.culture);
    }
    if (wauth.vcsStoreUrl) {
      siteConfigBuilder.withVCSStoreUrl(wauth.vcsStoreUrl);
    }
    const store: SiteConfigCookieStore = new SiteConfigCookieStore(
      getCookieDomain()
    );
    store.writeSiteConfig(siteConfigBuilder.build());
  }, [brand]);
}

export { useSiteConfigPersistor };
